import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaGithub, FaLinkedin, FaTwitter, FaInstagram, FaYoutube, FaFacebook, FaBars, FaTimes } from 'react-icons/fa';
import { useSocialLinks } from '../context/SocialLinksContext';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const { socialLinks } = useSocialLinks();

  useEffect(() => {
      const handleScroll = () => {
        const isScrolled = window.scrollY > 10;
        if (isScrolled !== scrolled) {
          setScrolled(isScrolled);
        }
      };

      document.addEventListener('scroll', handleScroll);
      return () => {
        document.removeEventListener('scroll', handleScroll);
      };
  }, [scrolled]);

  const toggleMenu = () => {
      setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
      setIsMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 80; // Adjust for navbar height
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
      closeMenu();
  };

  const navLinks = [
    { text: 'Home', id: 'home' },
    { text: 'About', id: 'about' },
    { text: 'Work', id: 'work' },
    { text: 'Innovations', id: 'innovations' },
    { text: 'YouTube', id: 'youtube' },
    { text: 'Blog', id: 'blog' },
    { text: 'Collaborate', id: 'collaborate' },
  ];

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-secondary/90 backdrop-blur-sm shadow-lg' : 'bg-transparent'}`}>
      <div className="container flex justify-between items-center py-4">
        <Link to="/" className="text-2xl font-bold text-white">
          <span className="text-primary">D</span>hiraj TH
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-8">
          <ul className="flex space-x-6">
            {navLinks.map((link, index) => (
              <li key={index}>
                <button
                  onClick={() => scrollToSection(link.id)}
                  className="text-white hover:text-primary transition-colors"
                >
                  {link.text}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-white focus:outline-none"
          onClick={toggleMenu}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
        >
          {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-50 bg-secondary flex flex-col justify-center items-center transition-transform duration-300 ease-in-out ${
          isMenuOpen ? 'translate-x-0' : 'translate-x-full'
        } md:hidden`}
      >
        <button
          className="absolute top-6 right-6 text-white focus:outline-none"
          onClick={toggleMenu}
          aria-label="Close menu"
        >
          <FaTimes size={24} />
        </button>

        <ul className="flex flex-col space-y-6 items-center">
          {navLinks.map((link, index) => (
            <li key={index}>
              <button
                onClick={() => scrollToSection(link.id)}
                className="text-white text-2xl hover:text-primary transition-colors"
              >
                {link.text}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar; 